'use strict';
// libphonenumber-js 1.13.12, MIT. Supported telephone countries and territories.
window.MCCPhone = (() => {
  const lib = window.libphonenumber;
  const names = new Intl.DisplayNames(['en'], {type:'region'});
  const countries = lib.getCountries().map(code => ({code, name:names.of(code), dial:lib.getCountryCallingCode(code)})).sort((a,b)=>a.name.localeCompare(b.name));
  function split(value, territory) {
    const parsed = value ? lib.parsePhoneNumberFromString(value) : null;
    const sameDial = countries.find(c=>c.code===territory && c.dial===parsed?.countryCallingCode);
    const country = parsed?.country || sameDial?.code || countries.find(c=>c.dial===parsed?.countryCallingCode)?.code || (lib.isSupportedCountry(territory||'')?territory:'IN');
    return {country, national:parsed?.nationalNumber || value || ''};
  }
  function format(country, value) {
    if (!value.trim()) return '';
    if (!lib.isSupportedCountry(country)) throw new Error('Choose a country calling code.');
    if (!/^[\d\s().-]+$/.test(value)) throw new Error('Enter only the phone number, without + or the country calling code.');
    const parsed = lib.parsePhoneNumberFromString(value,country);
    if (!parsed || !parsed.isPossible() || parsed.countryCallingCode!==lib.getCountryCallingCode(country)) throw new Error('Check the phone number and selected country calling code.');
    return parsed.number;
  }
  return {countries,split,format};
})();
